import React from 'react'

export default class extends React.Component {
  static defaultProps = {
    text: '!![No question text]!!',
    text_plain_language: '!![No question text in plain language]!!',
    id: null,
    locale: 'fi',
    odd_row: false,
    value: null,
    type: null,
    mandatory: false,
    plainText: false,
    onAnswer: () => {
    }
  };

  constructor(props) {
    super(props);
    let value = props.value
    let choices = props.choices
    let valueHasBeenSet = false
    if ((props.type === 'SO' || props.type === 'FT') && value === null) {
      value = ''  // react wants this..
    } else if (props.type === 'SC' && value === null) {
      value = 50  // default to value 50
    } else {
      valueHasBeenSet = true
    }

    this.state = {
      activeTimerId: null,
      onAnswerThrottlingTimer: null,
      active: false,
      choices: choices,
      value: value,
      answered: valueHasBeenSet
    };
  }

  throttleOnAnswer = (immediate) => {
    if (this.state.onAnswerThrottlingTimer !== null) {
      clearTimeout(this.state.onAnswerThrottlingTimer)
    }
    let timerId = null
    if (!immediate) {
      timerId = setTimeout(() => {
        this.props.onAnswer(this.props.id, this.state.value)
      }, 100)
    } else {
      this.props.onAnswer(this.props.id, this.state.value)
    }
    this.setState({ onAnswerThrottlingTimer: timerId })
  };

  updateValue = (event) => {
    const value = event.target.value
    this.setState({ value: value, answered: true, active: true })
    this.throttleOnAnswer()
  };

  updateScaleValue = (event) => {
    const value = event.target.value
    if (value === this.state.value) {
      return false
    }
    this.state.activeTimerId && clearTimeout(this.state.activeTimerId)
    const tim = setTimeout(() => {
      this.setState({ active: false })
    }, 3000)
    this.setState({ value: value, answered: true, active: true, activeTimerId: tim })
    this.throttleOnAnswer()
  };

  updateTextValue = (event) => {
    const value = event.target.value.substr(0, 500)
    this.setState({ value: value, answered: true, active: true })
    this.throttleOnAnswer()
  };

  handleBlur = (event) => {
    this.setState({ active: false })
    this.throttleOnAnswer(true)
  };

  percentageToText = (v) => {
    let index = 0
    if (v > 80) {
      index = 4
    } else if (v > 60) {
      index = 3
    } else if (v > 40) {
      index = 2
    } else if (v > 20) {
      index = 1
    }
    return this.state.choices[index][2]
  };

  percentageToTextOftenNever = (v) => {
    if (v > 80) {
      return I18N._('daily')
    } else if (v > 60) {
      return I18N._('weekly')
    } else if (v > 40) {
      return I18N._('monthly')
    } else if (v > 20) {
      return I18N._('seldomly')
    }
    return I18N._('never')
  };

  render() {
    let cssClasses = 'question ' + this.props.type + ' '
    if (this.props.odd_row) {
      cssClasses += 'odd '
    } else {
      cssClasses += 'even '
    }
    if (!this.state.answered) {
      cssClasses += 'unanswered '
    }
    if (this.state.active) {
      cssClasses += 'active '
    }

    return (
      <div data-question-id={this.props.id}
        className={cssClasses}>
        <label htmlFor={"q-" + this.props.id}>
          {
            this.props.plainText === true && this.props.text_plain_language !== null ?
              this.props.text_plain_language :
              this.props.text
          }
        </label>
        <div className="input">
          {
            this.props.type === 'SO' ?
              <div className="custom-select">
                <select className="form-control" id={"q-" + this.props.id}
                  name={this.props.id}
                  onBlur={this.handleBlur}
                  required={this.props.mandatory}
                  onChange={this.updateValue}
                  value={this.state.value}>
                  {this.state.choices.map((c, i) =>
                    <option key={c[0]} value={c[0]}> {c[2]} </option>
                  )}
                </select>
              </div>
              : (
                this.props.type == 'FT' ?
                  <div>
                    <div className="textarea-input">
                      <textarea id={"q-" + this.props.id} name={this.props.id} rows="5"
                        className="form-control"
                        onBlur={this.handleBlur}
                        onChange={this.updateTextValue}
                        value={this.state.value} />
                    </div>
                    <div className="question-chars-left">
                      <span>
                        {500 - (this.state.value ? this.state.value.length : 0)}
                        &nbsp; {I18N._("characters left", { locale: this.props.locale })}
                      </span>
                    </div>
                  </div>
                  :
                  <div>
                    <input id={"q-" + this.props.id}
                      name={this.props.id}
                      type="range" max="100" min="0" step="1"
                      onBlur={this.handleBlur}
                      required={this.props.mandatory}
                      onChange={this.updateScaleValue}
                      // two needed for IE11 https://github.com/facebook/react/issues/3096
                      onMouseUp={this.updateScaleValue}
                      onClick={this.updateScaleValue}
                      value={this.state.value} />

                    <div className="range-ticks">
                      <span className="first"></span>
                      <span className="second"></span>
                      <span className="third"></span>
                      <span className="fourth"></span>
                    </div>

                    <div className="range-legend">
                      <span>{this.state.choices[0][2]}</span>
                      <span>{this.state.choices[this.state.choices.length - 1][2]}</span>
                    </div>

                    <div className="range-explainer" style={{ "left": this.state.value + "%" }}>
                      <span>{this.percentageToText(this.state.value)}</span>
                    </div>

                    <div className="answered-indicator">
                      <span>✓</span>
                    </div>
                  </div>
              )
          }
        </div>
      </div>
    )
  }
}